module.exports = __webpack_public_path__ + "img/身份证正面.95c18123.png";